// extracted by mini-css-extract-plugin
module.exports = {"app-footer":"bg_dK","appFooter":"bg_dK","logo":"bg_dL","sub-footer":"bg_dM","subFooter":"bg_dM","links":"bg_dN","copy":"bg_dP"};